import { useDispatch, useSelector } from "react-redux";

import Cart from "../../../assets/icons/cart.svg";

import { setCart } from "../../../features/cart/reducer";
import { IRootState } from "../../..";

const CartIcon = () => {
  const cart = useSelector((state: IRootState) => state.cart.value);
  const dispatch = useDispatch();

  const { isActive } = cart;
  return (
    <div
      className="relative"
      onClick={() =>
        dispatch(
          setCart({
            isActive: !isActive,
          })
        )
      }
    >
      <img src={Cart} alt="" className="cursor-pointer" />
      {cart.cart.length > 0 && (
        <div className="absolute flex items-center justify-center p-2 w-3 h-3 bg-[#A62F00] rounded-full -top-[2px]  -right-[6px] text-xs  text-white">
          {cart.cart.length}
        </div>
      )}
    </div>
  );
};

export default CartIcon;
